import * as config from './ConfigAction';
import * as header from './HeaderAction';
import * as sidebar from './SidebarAction';
import * as hotelList from './HotelListAction';
import * as buildingList from './BuildingListAction';
import * as floorList from './FloorListAction';
import * as roomList from './RoomListAction';
import * as doorlockList from './DoorlockListAction';
import * as bookingList from './BookingListAction';
import * as staffList from './StaffListAction';
import * as reportList from './ReportListAction';
import * as doorlockTileList from './DoorlockTileListAction';

export const configAction = config;
export const headerAction = header;
export const sidebarAction = sidebar;
export const hotelListAction = hotelList;
export const buildingListAction = buildingList;
export const floorListAction = floorList;
export const roomListAction = roomList;
export const doorlockListAction = doorlockList;
export const bookingListAction = bookingList;
export const staffListAction = staffList;
export const reportListAction = reportList;
export const doorlockTileListAction = doorlockTileList;